import { Palette } from '@/themes/themeOverrides/Palette';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

export const marketingStyles = {
    adsCampaingsTile: {
        padding: '40px',
        borderRadius: '20px',
        minWidth: '480px',
        display: 'flex',
        backgroundColor: Palette.white,
        gap: '40px',
        boxShadow: Palette.boxShadow.elevation1,
        [`@media (max-width: ${breakpoints.values.xl}px)`]: {
            minWidth: '420px',
        },
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            flexDirection: 'column',
            minWidth: 'auto',
            gap: '12px',
            padding: '24px',
        },
        '& .tile-image-container': {
            width: '160px',
            height: '284px',
            borderRadius: '12px',
            border: `2px solid ${Palette.gray.gray100}`,
            margin: '0 0 20px 0',
            overflow: 'hidden',
            '& img': {
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '12px',
            },
        },
        '&:last-child:nth-of-type(odd)': {
            width: '100%',
            gridColumn: '1 / -1',
            maxWidth: '720px',
        },
        '& .MuiButtonBase-root': {
            width: '100%',
            fontSize: '11px',
            lineHeight: '16px',
            letterSpacing: '-0.11px',
            fontWeight: 500,
            padding: '7px 16px 7px 12px',
            borderRadius: '10px',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                width: 'auto',
                minWidth: '32px',
                padding: '8px',
                '& .MuiButton-startIcon': {
                    margin: 0,
                },
                '& .button-label': {
                    display: 'none',
                },
            },
        },
        '& .tile-actions .MuiIconButton-root.MuiButtonBase-root': {
            width: 'auto',
            flexShrink: 0,
        },
        '& .tile-image': {
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
            },
        },
        '& .tile-content': {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            '& .MuiTypography-root.MuiTypography-h5': {
                fontSize: '22px',
                lineHeight: '28px',
                paddingBottom: '24px',
                borderBottom: `2px solid ${Palette.gray.gray75}`,
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    fontSize: '18px',
                    lineHeight: '24px',
                    paddingBottom: '12px',
                },
            },
        },
        '& .tile-content-item': {
            display: 'flex',
            flexDirection: 'column',
            gap: '2px',
            padding: '10px 0',
            borderTop: `2px solid ${Palette.gray.gray75}`,
            '&:last-child': {
                borderBottom: `2px solid ${Palette.gray.gray75}`,
            },
            '& .MuiTypography-root.MuiTypography-caption': {
                fontSize: '11px',
                lineHeight: '16px',
                fontWeight: 400,
                letterSpacing: '-0.11px',
            },
            '& .MuiTypography-root.MuiTypography-body1': {
                fontSize: '14px',
                lineHeight: '20px',
                fontWeight: 400,
                letterSpacing: '-0.14px',
            },
        },
    },
    adsCampaignsPeriodItem: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        padding: '12px 0',
        fontWeight: 400,
        letterSpacing: '-0.14px',
        lineHeight: '20px',
        fontSize: '14px',
        '& .MuiChip-root': {
            borderRadius: '4px',
            height: '16px',
            '& .MuiChip-label': {
                paddingLeft: '6px',
                paddingRight: '6px',
            },
        },
    },
};
